(function() {

  function AssignmentSubTitleFilterFactory(
    assignedFocusApi) {
    return function(assignment) {
      if (assignedFocusApi.isNweaAssignment(assignment)) {
        if(assignedFocusApi.isLegacyNwea(assignment)) {
          return "";
        }
        return assignment.focusData.level;
      } else if (assignedFocusApi.isQuantileAssignment(assignment)) {
        return  assignment.focus_concept;
      } 

      return "";
    };
  }

  /**
   * This filter displays an assignment title given an assignment.
   */
  angular.module('edxComponents')
    .filter('edxAssignmentSubTitle', [
      'assignedFocusApi',
      AssignmentSubTitleFilterFactory
    ]);

})();
